<template>
  <div class="project-info-container">
    <Breadcrumb
      :company="$store.state.user.company_uid"
      :project="$route.params.project_uid"
    />

    <el-tabs v-model="tabActive" @tab-click="setTabActive">
      <el-tab-pane label="Project Info" name="project">
        <span slot="label"><i class="el-icon-info"></i> Project Info</span>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="vertical-align: -webkit-baseline-middle"
              ><i class="el-icon-s-flag"></i> Project Info</span
            >
            <el-select
              v-if="roleSuperAdmin"
              style="float: right; padding: 0"
              v-model="companySelected"
              placeholder="Goto Company"
              size="mini"
              @change="gotoCompany()"
            >
              <el-option
                v-for="item in dataCompany"
                :key="item.uid"
                :label="item.company_name"
                :value="item.uid"
              >
              </el-option>
            </el-select>
            <el-button
              style="
                margin-right: 10px;
                padding: 3px 0;
                vertical-align: -webkit-baseline-middle;
                float: right;
              "
              :icon="readonly ? 'el-icon-view' : 'el-icon-edit'"
              type="text"
              @click="editProject()"
              v-if="rolePrice"
              >{{ readonly ? "View" : "Edit" }}</el-button
            >
          </div>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-form class="info-project">
                <el-form-item label="Project Name">
                  {{ this.projectInfo.project_name }}
                </el-form-item>
                <el-form-item label="Distribution code">
                  {{ this.projectInfo.distribution_code }}
                </el-form-item>
                <el-form-item label="Prefix code">
                  {{ this.projectInfo.prefix_code }}
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="8">
              <UploadLogo v-if="rolePrice" :projectUID="projectUID" />
            </el-col>
          </el-row>
        </el-card>
        <BankBalance
          ref="bankBalanace"
          :projectUID="projectUID"
          :bank-account-numbers="bankNumAccount"
          apiMode="project"
          v-if="rolePrice && tabActive === 'project'"
        />
      </el-tab-pane>

      <el-tab-pane label="Bank Account" name="bankaccount" v-if="rolePrice">
        <BankAccountManager
          v-if="
            Object.keys(projectInfo).length > 0 && tabActive === 'bankaccount'
          "
          :projectUID="projectUID"
          :customerUID="projectInfo.company_uid"
          v-on:numbers="getBankNumbers"
          apiMode="project"
          :readonlyMode="!roleSuperAdmin"
          :showAccountNumber="false"
        />
      </el-tab-pane>

      <el-tab-pane label="Customer" name="customer">
        <CustomerManager
          v-if="Object.keys(projectInfo).length > 0 && tabActive === 'customer'"
          :projectUID="projectUID"
          :referrence="'project'"
        />
      </el-tab-pane>

      <el-tab-pane label="Report" name="report" v-if="rolePrice">
        <Report :project="projectUID" v-if="tabActive === 'report'" />
      </el-tab-pane>

      <el-tab-pane label="Beneficiary" name="beneficiary" v-if="roleSuperAdmin">
        <BeneficiaryManager
          :projectUID="projectUID"
          v-if="tabActive === 'beneficiary'"
        />
      </el-tab-pane>

      <el-tab-pane label="Currency" name="currency" v-if="rolePrice">
        <CurrencyManager
          :project="projectUID"
          @goto-pricing="gotoPricing"
          v-if="tabActive === 'currency'"
        />
      </el-tab-pane>
      <el-tab-pane label="Pricing setting" name="price" v-if="rolePrice">
        <span slot="label"
          ><i class="el-icon-setting"></i> Pricing setting</span
        >
        <PricingManager
          ref="pricingmanager"
          v-if="Object.keys(projectInfo).length > 0 && tabActive === 'price'"
          :projectUID="projectUID"
        />
      </el-tab-pane>
      <el-tab-pane
        label="Rules"
        name="rules"
        v-if="roleSuperAdmin || userFirewallSetting"
      >
        <Rules
          :projectUID="projectUID"
          :companyUID="projectInfo.company_uid"
          v-if="tabActive === 'rules'"
        />
      </el-tab-pane>
      <el-tab-pane
        label="Blacklist"
        name="blacklist"
        v-if="roleSuperAdmin || userFirewallSetting"
      >
        <Blacklist
          :projectUID="projectUID"
          :companyUID="projectInfo.company_uid"
          v-if="tabActive === 'blacklist'"
        />
      </el-tab-pane>
      <el-tab-pane
        label="Whitelist"
        name="whitelist"
        v-if="roleSuperAdmin || userFirewallSetting"
      >
        <Whitelist v-if="tabActive === 'whitelist'" />
      </el-tab-pane>

      <el-tab-pane label="Monthly Visualization Report" name="visualization">
        <MonthlyChargeVisualization />
      </el-tab-pane>
    </el-tabs>

    <ProjectEditForm
      v-if="dialogFormVisible"
      :companyUID="companySelected"
      :dialog-show.sync="dialogFormVisible"
      :formData="projectInfo"
      @on-submited="onSubmited"
    />
  </div>
</template>

<script>
import { getProjectBy, projectActive } from "@/api/project";
import { getCompany } from "@/api/company";
import CustomerManager from "@/views/customer/components/customer-manager";
import BankAccountManager from "@/views/bank-account/components/bank-account-manager";
import PricingManager from "@/views/pricing/pricing-manager";
import BankBalance from "@/views/bank-account/components/balance";
import Breadcrumb from "@/components/Breadcrumb";
import ProjectEditForm from "@/views/project/components/edit-form";
import Report from "@/views/project/components/project-report";
import BeneficiaryManager from "@/views/beneficiary/components/beneficiary-project-manager";
import CurrencyManager from "@/views/currency/index";
import Rules from "@/views/rules/index";
import Blacklist from "@/views/blacklist/index";
import Whitelist from "@/views/whitelist/components/whitelist-project";
import MonthlyChargeVisualization from "@/views/report/components/monthly-charge-visualization";
import UploadLogo from "@/views/project/components/upload-project-logo";
export default {
  components: {
    CustomerManager,
    BankAccountManager,
    PricingManager,
    BankBalance,
    Breadcrumb,
    ProjectEditForm,
    Report,
    BeneficiaryManager,
    CurrencyManager,
    Rules,
    Blacklist,
    Whitelist,
    MonthlyChargeVisualization,
    UploadLogo
  },
  watch: {
    $route() {
      this.gotoPricing();
    }
  },
  computed: {
    roleSuperAdmin() {
      return this.roleAuth([this.role.spadmin]);
    },
    rolePrice() {
      return this.roleAuth([this.role.spadmin, this.role.admin]);
    },
    userFirewallSetting() {
      return this.$store.state.user.flag_firewallsetting;
    },
    readonly() {
      return this.roleAuth([this.role.admin]);
    }
  },
  data() {
    return {
      projectUID: "",
      projectInfo: {},
      dataCompany: [],
      companySelected: "",
      tabActive: this.$route.query.tab || "project",
      bankNumAccount: 0,
      dialogFormVisible: false
    };
  },

  methods: {
    getCompanyData() {
      getCompany().then(({ result, data }) => {
        if (result) {
          this.dataCompany = data;
        }
      });
    },
    getProjectInfo() {
      const loading = this.$notifyloading("Loading data...");
      this.roleSuperAdmin && this.getCompanyData();
      this.projectUID = this.$route.params.project_uid;
      getProjectBy(this.projectUID).then(({ result, data }) => {
        loading.close();
        if (result) {
          this.projectInfo = data;
          this.companySelected = data.company_uid;
          this.setProjectActive(this.projectUID);
        }
      });
    },
    setProjectActive(projectUID) {
      projectActive(projectUID).then(async ({ result }) => {
        if (result) {
          await this.$store.dispatch("user/getInfo");
        }
      });
    },
    gotoCompany() {
      this.$router.push("/company/info/" + this.companySelected);
    },
    getBankNumbers(numbers) {
      this.bankNumAccount = numbers;
    },
    setTabActive(tab) {
      this.$router.push("?tab=" + tab.name);
    },
    editProject() {
      this.dialogFormVisible = true;
    },
    onSubmited() {
      this.getProjectInfo();
    },

    gotoPricing() {
      // console.log(currency)
      if (this.$route.query.tab == "price") {
        this.tabActive = "price";
        let currency = this.$route.query.currency;

        if (currency) {
          this.$router.push("?tab=price&currency=" + currency);
          this.$refs.pricingmanager.load(currency);
        }
      }
    }
  },

  created() {
    this.getProjectInfo();
  }
};
</script>

<style lang="scss">
.project-info-container {
  .info-project {
    .el-form-item {
      margin-bottom: 0px;
    }
  }
}
</style>

